var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isString)?_c('p',[_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_c('FSXARichText',{attrs:{"content":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }